<template>
  <component
    :is="url ? 'a' : 'div'"
    :href="url || undefined"
    class="google-badge"
  >
    <div class="google-badge__caption">{{ texts.reviewsOn }}</div>
    <google-logo class="google-badge__logo" />
    <div class="google-badge__as-of">
      {{ texts.tillOchMed }} {{ currentMonthYear }}
    </div>
    <div v-if="rating" class="google-badge__rating">
      <span class="google-badge__rating-value">{{ rating }}</span>
      <review-stars
        :count="5"
        :size="14"
        color="#fbbc05"
        :spacing="1"
        :aria-label="`${rating} / 5`"
      />
    </div>
  </component>
</template>

<script>
import { format } from 'date-fns';
import { useDateFormatter } from 'Composables/useDateFormatter';
import ReviewStars from './ReviewStars.vue';
import GoogleLogo from './GoogleLogo.vue';

export default {
  name: 'GoogleBadge',

  components: {
    ReviewStars,
    GoogleLogo,
  },

  props: {
    rating: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { getLocale } = useDateFormatter();
    return { getLocale };
  },

  data() {
    return {
      texts: window.theme_vars.trustpilot,
    };
  },

  computed: {
    currentMonthYear() {
      try {
        return format(new Date(), 'MMMM yyyy', { locale: this.getLocale() });
      } catch {
        return '';
      }
    },
  },
};
</script>
